module.exports = __webpack_public_path__ + "img/melhores_gptw.bc879527.png";